const descriptionsKey = Symbol("elDescriptions");

export { descriptionsKey };
//# sourceMappingURL=token.mjs.map
